import { Paper, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { memo, useState } from 'react';

import { TrlNewsContent } from '»components/molecules';
import { TrlDateFormatted } from '»utils/date';

import { TrlModalBottomBar } from '../TrlModalBottomBar';
import { TrlNewsTitle } from '../TrlNewsTitle';
import { DialogStyled, PaperStyled, TrlOuterModal } from '../TrlOuterModal';
import {
  ContentText,
  DateLabel,
  SummaryContainer,
} from './TrlNewsSummary.styles';

const getPaperComponent = (props, isMobile) =>
  isMobile ? <Paper {...props} /> : <PaperStyled {...props} />;

export const TrlNewsSummary = memo(
  ({
    date,
    title,
    sourceId,
    image,
    link,
    contSeq,
    fileName,
    fileDescr,
    visibleFile,
    video,
  }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    const [openDetailsModal, setOpenDetailsModal] = useState(false);

    const handleOpenDetailsModal = (value) => {
      setOpenDetailsModal(value);
    };

    const openNewsLink = () => {
      window.open(link);
    };

    const newsDate = `${TrlDateFormatted({ date })} | ${sourceId}`;

    return (
      <SummaryContainer>
        <DialogStyled
          fullScreen={isMobile}
          open={openDetailsModal}
          onClose={() => handleOpenDetailsModal(false)}
          PaperComponent={(props) =>
            getPaperComponent({ ...props, isNewsModal: true }, isMobile)
          }
        >
          {isMobile ? (
            <>
              <TrlNewsContent
                title={title}
                image={image}
                date={newsDate}
                contSeq={contSeq}
                fileName={fileName}
                fileDescr={fileDescr}
                visibleFile={visibleFile}
                video={video}
                isInModal
                isModalOpened={openDetailsModal}
                handleTitleClick={link ? openNewsLink : null}
              />
              <TrlModalBottomBar
                text="TRLT_UI-DASHBOARD"
                handleClick={() => {
                  handleOpenDetailsModal(false);
                }}
              />
            </>
          ) : (
            <TrlOuterModal
              title="TRLT_UI-RECENT_NEWS"
              handleClose={() => handleOpenDetailsModal(false)}
              innerBackgroundColor={theme.palette.colors.newsBackground}
              isNewsModal
            >
              <TrlNewsContent
                title={title}
                image={image}
                date={newsDate}
                contSeq={contSeq}
                fileName={fileName}
                fileDescr={fileDescr}
                visibleFile={visibleFile}
                video={video}
                isInModal
                isModalOpened={openDetailsModal}
                handleTitleClick={link ? openNewsLink : null}
              />
            </TrlOuterModal>
          )}
        </DialogStyled>

        <DateLabel>
          <TrlDateFormatted date={date} />
        </DateLabel>

        <ContentText>
          <TrlNewsTitle
            title={title}
            handleClick={() => handleOpenDetailsModal(true)}
          />{' '}
          {sourceId}
        </ContentText>
      </SummaryContainer>
    );
  },
);

TrlNewsSummary.displayName = 'TrlNewsSummary';

TrlNewsSummary.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  sourceId: PropTypes.string.isRequired,
  image: PropTypes.string,
  link: PropTypes.string,
  contSeq: PropTypes.number.isRequired,
  fileName: PropTypes.string,
  fileDescr: PropTypes.string,
  visibleFile: PropTypes.oneOf(['Y', 'N']),
  video: PropTypes.string,
};
